<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 子组件 - 分享区域主副标题
  -->
    <div class="xtc-share-title">
      <div v-if="mainTitle" class="main_title">{{mainTitle}}</div>
      <div v-if="subTitle" class="sub_title">{{subTitle}}</div>
    </div>
</template>
<script>
export default {
  props: {
    mainTitle: {
      type: String,
      default: 'Share Politely'
    },
    subTitle: {
      type: String,
      default: 'Each person invited will receive $5'
    }
  },
  data () {
    return {

    }
  }
}
</script>
<style scoped lang="stylus">
.xtc-share-title {
  // ①位置属性：左上定位
  // ②元素属性：颜色/字体
  .main_title {
    width: 100%;
    height: 36px;
    // font-family: DiDiSansPro-Medium;
    font-family: Aspira Medium;
    font-size: 36px;
    color: #000000;
    line-height: 36px;
    font-weight: 500;
  }
  .sub_title {
    margin-top: 12px;
    width: 638px;
    // height: 28px;
    word-break: break-all;
    height: fit-content;
    // font-family: DiDiSansPro-Regular;
    font-family: 'Aspira Regular';
    font-size: 28px;
    color: #666666;
    letter-spacing: 0;
    line-height: 28px;
    font-weight: 400;
  }
}
</style>